import cloneDeep from 'lodash/cloneDeep';
import { mapGetters } from 'vuex';

import { enableShareLink } from '@/api/orders';
import bus from '@/utils/bus';
import { FRONT_STAGE_URL, SNACKBAR_TYPES } from '@/utils/constants';

export default {
  name: 'EnableCustomLinkModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isEnablingLink: false,
    };
  },
  computed: {
    ...mapGetters(['isProduction']),
    shareLink() {
      const domain = this.isProduction ? FRONT_STAGE_URL.PRODUCTION : FRONT_STAGE_URL.STAGING;
      return `${domain}/menu/${this.order.id}?share=${this.order?.share?.share_key}`;
    },
  },
  methods: {
    onClose() {
      this.$emit('input', false);
      this.$emit('close');
    },
    onCopySuccess({ contentType = '訪客訂購連結' }) {
      this.$snackbar({
        type: SNACKBAR_TYPES.SUCCESS,
        title: `${contentType}已複製到剪貼簿`,
      });
    },
    onCopyError() {
      this.$snackbar({
        type: SNACKBAR_TYPES.ERROR,
        title: '複製訪客訂購連結失敗，請手動複製連結',
      });
    },
    async onEnableShareLink() {
      this.isEnablingLink = true;
      try {
        await enableShareLink({
          enable: true,
          orderId: this.order.id,
        });
        const copy = cloneDeep(this.order);
        copy.share.share_status = true;
        bus.$emit('SET_ORDER', copy);
        this.onClose();
      } catch (error) {
        const { message: msg = '' } = error;
        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          title: '開啟訪客訂購連結失敗，請重試一次',
          msg,
        });
      } finally {
        this.isEnablingLink = false;
      }
    },
  },
};
